
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"85","height":"85","viewBox":"0 0 85 85"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"play2","transform":"translate(0 -0.5)"}},[_c('circle',{attrs:{"id":"Ellipse_282","data-name":"Ellipse 282","cx":"42.5","cy":"42.5","r":"42.5","transform":"translate(0 0.5)","fill":"#ff0009"}}),_c('g',{attrs:{"id":"Group_20747","data-name":"Group 20747","transform":"translate(32.189 23.683)"}},[_c('path',{attrs:{"id":"Path_189810","data-name":"Path 189810","d":"M168.18,644.85a9.413,9.413,0,0,1,.567,3.413c0,2.927-1.707,5.773-6.014,9.026-7.4,5.69-11.951,9.184-14.554,11.381-2.682-.9-4.146-2.6-4.146-5.124,0-3.821,3.579-7.886,10.246-13.737-7.4-4.8-9.919-8.374-9.919-11.626,0-4.553,3.252-7.562,7.153-7.562a9.854,9.854,0,0,1,2.033.245C155.578,633.873,158.829,637.7,168.18,644.85Z","transform":"translate(-144.033 -630.621)","fill":"#fff"}})])])])
          )
        }
      }
    